export type T = {
  id: number;
  fn: () => void;
  isDestroy: boolean;
  destroy: () => void;
};

export type LZD_RENDER_T = {
  promise: Promise<void>;
  resolve: (value: void | PromiseLike<void> | T) => void;
  reject: (value: string) => void;
  destroy: () => void;
} | null;

/** 渲染队列 */
export class LzdRenderQueue {
  private data: T[] = [];
  private count: number;
  private running = false;
  constructor(count?: number) {
    let _count = count ?? navigator.hardwareConcurrency ?? 4;
    _count = Math.round(_count / 2 - 2);
    this.count = _count < 4 ? 4 : _count;
  }

  /** 添加元素 */
  enqueue(item: T): void {
    this.data.push(item);
    if (!this.running) {
      globalThis.requestAnimationFrame(() => this._run());
    }
    this.running = true;
  }

  /** 批量出队（最多 count 个） */
  dequeueBatch() {
    this.clearDestroy();
    const batch = this.data.slice(0, this.count);
    this.data = this.data.slice(this.count);
    return batch;
  }

  /** 清除禁止渲染的 */
  clearDestroy() {
    let index = -1;
    while ((index = this.data.findIndex((d) => d.isDestroy)) !== -1) {
      this.data.splice(index, 1);
    }
  }

  peek(): T | undefined {
    return this.data[0];
  }

  isEmpty(): boolean {
    return this.data.length === 0;
  }

  size(): number {
    return this.data.length;
  }

  private async _run() {
    if (this.isEmpty()) {
      this.running = false;
      return;
    }
    this.running = true;
    const tasks = this.dequeueBatch();
    for (const task of tasks) {
      try {
        !task.isDestroy && task.fn?.();
      } catch (err) {
        console.error('Render task error:', err);
      }
    }

    globalThis.requestAnimationFrame(() => this._run());
  }
}

/** 渲染任务队列 */
const TASK_RENDER_QUEUE = new LzdRenderQueue();
0;
let RENDER_INDEX = 0;

/** 渲染等待函数 */
export function renderNext(func: (e: number) => void) {
  const currId = RENDER_INDEX++;

  let resolve: (value: void | PromiseLike<void> | T) => void = () => {};
  let reject: (value: string) => void = () => {};
  const promise = new Promise<void>((_resolve, _reject) => {
    resolve = _resolve;
    reject = _reject;
  });

  const task: T = {
    id: currId,
    fn() {
      try {
        func?.(currId);
      } catch (err) {
        console.error('Error in renderNext callback:', err);
      } finally {
        resolve?.(this);
      }
    },
    isDestroy: false,
    destroy() {
      if (!this.isDestroy) {
        this.isDestroy = true;
        reject?.('组件卸载终止渲染任务');
      }
    }
  };
  TASK_RENDER_QUEUE.enqueue(task);

  return { promise, resolve, reject, destroy: task.destroy };
}
